import type { PostFormat } from "@nlc/shared-types";
import type { ReactNode } from "react";

const COLORS = {
  frame: "#CBD5E1",
  icon: "#94A3B8",
  line: "#E2E8F0",
  mountain: "#A99BE8",
  photo: "#EDE8FF",
  play: "#6535F5",
  sun: "#C9BEF5",
};

export function PostTypeIllustration({
  className,
  format,
}: {
  className?: string;
  format: PostFormat;
}) {
  const Illustration = ILLUSTRATIONS[format];

  return (
    <svg aria-hidden className={className} fill="none" viewBox="0 0 98 168">
      <rect
        fill="white"
        height="166"
        rx="14"
        stroke={COLORS.frame}
        strokeWidth="2"
        width="96"
        x="1"
        y="1"
      />
      <Illustration />
    </svg>
  );
}

const ILLUSTRATIONS: Record<PostFormat, () => ReactNode> = {
  post: Post,
  reel: Reel,
  story: Story,
};

function Post() {
  return (
    <>
      <circle cx="17" cy="19" fill={COLORS.sun} r="6" />
      <Bar fill={COLORS.line} width={30} x={28} y={16} />
      <rect fill={COLORS.photo} height="82" width="88" x="5" y="31" />
      <circle cx="71" cy="51" fill={COLORS.sun} r="8" />
      <path d="M5 113L31 79L49 97L67 73L93 113H5Z" fill={COLORS.mountain} />
      <g stroke={COLORS.icon} strokeWidth="1.8">
        <circle cx="15" cy="125" r="4" />
        <circle cx="29" cy="125" r="4" />
        <path d="M41 122L50 125L41 128V122Z" strokeLinejoin="round" />
        <rect height="10" rx="1.5" width="8" x="81" y="120" />
      </g>
      <Bar fill={COLORS.line} width={62} x={9} y={139} />
      <Bar fill={COLORS.line} width={40} x={9} y={149} />
    </>
  );
}

function Reel() {
  return (
    <>
      <FullScreenPhoto />
      <circle cx="49" cy="71" fill={COLORS.play} r="14" />
      <path d="M44 64V78L56 71L44 64Z" fill="white" />
      <g stroke="white" strokeWidth="1.8">
        <circle cx="83" cy="103" r="4" />
        <circle cx="83" cy="117" r="4" />
        <path d="M79 129L87 132L79 135V129Z" strokeLinejoin="round" />
      </g>
      <circle cx="15" cy="143" fill="white" r="5" />
      <Bar fill="white" width={28} x={24} y={140} />
    </>
  );
}

function Story() {
  return (
    <>
      <FullScreenPhoto />
      <rect fill="white" height="3" rx="1.5" width="24" x="11" y="11" />
      <rect fill={COLORS.sun} height="3" rx="1.5" width="24" x="38" y="11" />
      <rect fill={COLORS.sun} height="3" rx="1.5" width="22" x="65" y="11" />
      <circle cx="17" cy="27" fill={COLORS.sun} r="5" />
      <Bar fill="white" width={26} x={26} y={24} />
      <g stroke="white" strokeWidth="1.8">
        <rect height="14" rx="7" width="50" x="11" y="139" />
        <circle cx="71" cy="146" r="4" />
        <path d="M79 143L87 146L79 149V143Z" strokeLinejoin="round" />
      </g>
    </>
  );
}

function FullScreenPhoto() {
  return (
    <>
      <rect fill={COLORS.photo} height="158" rx="10" width="88" x="5" y="5" />
      <circle cx="69" cy="61" fill={COLORS.sun} r="9" />
      <path
        d="M5 149L27 99L45 127L63 91L93 149V153H5V149Z"
        fill={COLORS.mountain}
      />
    </>
  );
}

function Bar({
  fill,
  width,
  x,
  y,
}: {
  fill: string;
  width: number;
  x: number;
  y: number;
}) {
  return <rect fill={fill} height="5" rx="2.5" width={width} x={x} y={y} />;
}
